import api from "./api";

export const getGrmDetails = async (payload = {}) => {
  try {
    const response = await api.post("/api/v1/grm/customer/search", payload);
    return response.data;
  } catch (error) {
    console.error("getGrmDetails failed, returning fallback response:", error);
    return null;
  }
};

export const getGrmOrderHistory = async (payload = {}) => {
  try {
    const response = await api.post("/api/v1/grm/order/history", payload);
    return response.data;
  } catch (error) {
    console.error(
      "getGrmOrderHistory failed, returning fallback response:",
      error,
    );
    return null;
  }
};

export const createGrmCustomer = async (payload = {}) => {
  try {
    const response = await api.post("/api/v1/grm/customer/create", payload);
    return response.data;
  } catch (error) {
    console.error("createGrmCustomer failed:", error);
    return null;
  }
};

export const editGrmCustomer = async (customerId, payload = {}) => {
  try {
    const response = await api.post(
      `/api/v1/grm/customer/${customerId}/edit`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("editGrmCustomer failed:", error);
    return null;
  }
};

export const addGrmCustomerPrescriptionFile = async (
  customerId,
  payload = {},
) => {
  try {
    const response = await api.post(
      `/api/v1/grm/customer/file/${customerId}/add-prescription`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("addGrmCustomerPrescriptionFile failed:", error);
    return null;
  }
};

export const searchGrmProducts = async (payload = {}) => {
  try {
    const response = await api.post("/api/v1/grm/products/search", payload);
    return response.data;
  } catch (error) {
    console.error("searchGrmProducts failed:", error);
    return null;
  }
};

export const createGrmOrder = async (memberProgramId, payload = {}) => {
  try {
    const response = await api.post(
      `/api/v1/grm/order/create/${memberProgramId}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("createGrmOrder failed:", error);
    return null;
  }
};

export const getGrmOrderDetails = async (orderId) => {
  try {
    const response = await api.get(`/api/v1/grm/order/${orderId}`);
    return response.data;
  } catch (error) {
    console.error("getGrmOrderDetails failed:", error);
    return null;
  }
};

export const addGrmOrderNote = async (orderId, payload = {}) => {
  try {
    const response = await api.post(
      `/api/v1/grm/order/notes/${orderId}/add`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("addGrmOrderNote failed:", error);
    return null;
  }
};
